import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const StyledWarningCard = styled.div<{ variant: 'WARNING' | 'INFO' }>`
  border-style: solid;
  border-width: 2px;
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  padding: ${({ theme }): string => theme.spacing_unit_x2};
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};

  svg {
    margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  }

  ${({ variant, theme }): FlattenSimpleInterpolation => {
    switch (variant) {
      case 'INFO':
        return css`
          border-color: ${theme.palette_blue_100};
          background-color: ${theme.palette_blue_0};

          svg {
            fill: ${theme.palette_blue_100};
          }
        `;
      case 'WARNING':
        return css`
          border-color: ${theme.palette_warning_5};
          background-color: ${theme.palette_warning_5};

          svg {
            fill: ${theme.palette_warning_50};
          }
        `;
    }
  }}
  & > div {
    display: flex;
    align-items: center;
  }
`;
